import * as api from '../api';
import { formatNumber, recalculate } from "../functions";
import { getCustomerGuid } from "../customer";

if ($('body').hasClass('in-klient-platby')) {

	$('#content-in .header-level-3').after('<a href="#" class="update-payment-cart">Aktualizovat platební kartu</a>');


	$(document).on('click', '.update-payment-cart', function (e) {
		e.preventDefault();
		var msg = "Pro aktualizaci vaší platební karty, je potřeba provést inicializační platbu ve výši 1 Kč vč DPH.\n\nKliknutím na tlačítko OK budte přesměrování na platební bránu.";
		if(confirm(msg)) {
			showSpinner();
			api.getData('update-payment-card', {guid: getCustomerGuid()})
				.done(function (data) {
					shoptet.cookie.create('init_subscription_card', data.code, {days: 1});
					window.location.href = data.paymentUrl;
				})
		}
	})


	$('a[href*="/paymentCardDelete"]').attr('onclick', '');
	$(document).on('click','a[href*="/paymentCardDelete"]', function(e) {
		e.preventDefault();
		var url = $(this).attr('href');
		if (window.confirm('Jste si jistí, že chcete smazat vybranou položku?')) {
			showSpinner();
			api.getData('forgot-card', {guid: getCustomerGuid()})
				.done(function () {
					window.location.href = url;
				})
		}
	});

}



